import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { BrandLogo } from "@/components/BrandLogo";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== confirm) { toast.error("Les mots de passe ne correspondent pas"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pwd });
      toast.success("Mot de passe modifié. Vous pouvez vous connecter.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="tricolor-bar fixed top-0 left-0 right-0" />
      <form onSubmit={submit} className="w-full max-w-md bg-card border border-border rounded-2xl p-7 space-y-4" data-testid="reset-password-form">
        <BrandLogo size={52} textClass="text-xl" testId="reset-brand-logo" />
        <h1 className="font-heading text-2xl font-extrabold flex items-center gap-2 pt-2"><KeyRound className="h-6 w-6 text-blue-600" />Nouveau mot de passe</h1>
        {!token && <p className="text-sm text-red-600" data-testid="reset-missing-token">Lien invalide : aucun jeton fourni.</p>}
        <div><Label>Nouveau mot de passe</Label><Input data-testid="reset-password-input" type="password" minLength={6} required value={pwd} onChange={(e) => setPwd(e.target.value)} className="mt-1.5" /></div>
        <div><Label>Confirmer</Label><Input data-testid="reset-password-confirm" type="password" minLength={6} required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5" /></div>
        <Button type="submit" disabled={loading || !token} data-testid="reset-password-submit" className="w-full h-11 bg-blue-700 hover:bg-blue-800">
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Valider"}
        </Button>
        <button type="button" onClick={() => navigate("/login")} className="w-full text-sm text-blue-700 font-semibold hover:underline" data-testid="reset-back-login">Retour à la connexion</button>
      </form>
    </div>
  );
}
